window.continueIfAllowed = (controller, actions) ->
  current_classes = $('body')[0].classList
  current_controller = current_classes[0]
  current_action = current_classes[1]
  current_controller == controller && $.inArray(current_action, actions) > -1
